{
  "version": 1,
  "asset_id": "1eb0d0f9-5460-4d53-b8be-bbdf110c7756",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/1eb0d0f9-5460-4d53-b8be-bbdf110c7756/angelika-wielgus-lach.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/1eb0d0f9-5460-4d53-b8be-bbdf110c7756/angelika-wielgus-lach.jpg",
  "original_filename": "angelika-wielgus-lach.jpg",
  "size": 72384,
  "content_type": "image/jpeg",
  "created_at": "2026-09-17T14:52:55Z"
}
